<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { propTypes } from '@/utils/propTypes'
import { parseIconName, getIconBody } from './iconData'

const props = defineProps({
  // icon name
  icon: propTypes.string,
  // icon color
  color: propTypes.string,
  // icon size
  size: propTypes.number.def(16),
  hoverColor: propTypes.string
})

const iconBody = ref('')

// 解析图标并异步获取 SVG body
async function resolveIcon(icon: string) {
  if (!icon) {
    iconBody.value = ''
    return
  }
  const { prefix, name } = parseIconName(icon)
  if (!prefix) {
    iconBody.value = ''
    return
  }
  const body = await getIconBody(prefix, name)
  iconBody.value = body
}

// 监听 icon prop 变化，重新解析
watch(
  () => props.icon,
  (newIcon) => {
    resolveIcon(newIcon)
  },
  { immediate: true }
)

const svgAttrs = computed(() => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: props.size,
  height: props.size,
  viewBox: '0 0 24 24',
  style: {
    color: props.color || 'currentColor'
  }
}))
</script>

<template>
  <div class="icon-wrapper">
    <svg v-bind="svgAttrs" v-html="iconBody"></svg>
  </div>
</template>

<style lang="less" scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    display: inline-block;
    vertical-align: middle;

    &:hover {
      color: v-bind(hoverColor);
    }
  }
}
</style>
